import { rootAxios } from "@/common/api/axios";
import { useQuery } from "@tanstack/react-query";

export const useServerHealthCheck = () => {
  return useQuery({
    refetchInterval: 15000,
    queryKey: ['serverHealthCheck'],
    queryFn: () => rootAxios.get(`/health_check`),
  });
};
